export default {
  ev_charging_pile: {
    title: '充电桩',
    business_statuses: {
      operating: '运营中',
      maintaining: '维护中',
      unavailable: '已下架',
      unknown: '未知'
    },
    statuses: {
      available: '空闲',
      charging: '充电中'
    },
    plug_types: {
      national_standard: '国标',
      european_standard: '欧标',
      american_standard: '美标'
    },
    charger_types: {
      ac: '交流',
      dc: '直流',
      dc_ac: '交直流'
    },
    source_types: {
      ecmp: '平台监控',
      evcs: '互联互通',
      others: '其他'
    },
    param_keys: {
      keyword: '关键字',
      plug_type: '枪口类型',
      charger_type: '电桩类型',
      status: '状态',
      business_status: '业务状态',
      created_at: '创建日期',
      max_power: '最大输出功率',
      source_type: '信息来源',
      service_provider: '运营商'
    },
    detail_page: {
      gun: '枪',
      clone: '克隆'
    },
    tips: {
      no_gun: '暂未设置枪口信息'
    }
  }
}
